import React, { useState } from 'react';
import { Popover } from 'antd';
const FilterPopover = ({ actionButton: ActionButton, content: Content }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (<Popover content={() => <Content onDismiss={() => setIsOpen(false)} popoverIsOpen={isOpen}/>} trigger='click' placement='bottomLeft' visible={isOpen} arrowPointAtCenter onVisibleChange={setIsOpen}>
      <ActionButton onClick={() => setIsOpen(open => !open)}/>
    </Popover>);
};
export default FilterPopover;
